// 1. Import statements at the very top of the file
import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { persistReducer, persistStore } from "redux-persist";
import { selectedDataReducer } from "../Slice/selectRowSlice.js";
import sessionMiddleware from "../middleware/sessionMiddleware.js";
import { userAuthApi } from "../services/userAuthApi.js";
import authInfoReducer from "../Slice/authSlice.js";
import { adminApi } from "../services/adminApi.js";
// import storage from "redux-persist/lib/storage";  // This should be the first import
import { staffApi } from "../services/ClientAPis/staffApi.js";
import { patientApi } from "../services/ClientAPis/patientApi.js";
import { baseApi, baseReducer } from "../services/baseApi.js";
import { taskApi } from "../services/ClientAPis/taskApi.js";
import { appointmentApi } from "../services/ClientAPis/appointmentApi.js";
import { billingApi } from "../services/ClientAPis/billingApi.js";
import { staffAttendanceApi } from "../services/ClientAPis/staffAttendance.js";

// 2. Then, the rest of your logic follows:
const persistConfig = {
  key: "root",
  // storage, 
  blacklist: [], // Reducer keys to omit from persisting
};

const rootReducer = {
  [baseApi.reducerPath]: baseReducer,
  [userAuthApi.reducerPath]: userAuthApi.reducer,
  [adminApi.reducerPath]: adminApi.reducer,
  [staffApi.reducerPath]: staffApi.reducer,
  [patientApi.reducerPath]: patientApi.reducer,
  [taskApi.reducerPath]: taskApi.reducer,
  [appointmentApi.reducerPath]: appointmentApi.reducer,
  [billingApi.reducerPath]: billingApi.reducer,
  [staffAttendanceApi.reducerPath]: staffAttendanceApi.reducer,
  selectedData: selectedDataReducer,
  authInfo: authInfoReducer,
};

// const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: rootReducer, 
  preloadedState: loadFromLocalStorage(), 
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST"], 
      },
    }).concat([
      baseApi.middleware,
      userAuthApi.middleware,
      adminApi.middleware,
      staffApi.middleware,
      patientApi.middleware,
      taskApi.middleware,
      appointmentApi.middleware,
      billingApi.middleware,
      staffAttendanceApi.middleware,
      sessionMiddleware,
    ]), 
});

// export const persistor = persistStore(store);

function saveToLocalStorage(state) {
  try {
    const serialState = JSON.stringify(state);
    localStorage.setItem("reduxStore", serialState);
  } catch (e) {
    console.warn(e);
  }
}

function loadFromLocalStorage() {
  try {
    const serialisedState = localStorage.getItem("reduxStore");
    if (serialisedState === null) return undefined;
    return JSON.parse(serialisedState);
  } catch (e) {
    console.warn(e);
    return undefined;
  }
}

store.subscribe(() => saveToLocalStorage(store.getState()));

setupListeners(store.dispatch);
